<template>
    <vs-sidebar
        click-not-close
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="commissionSettingConfig.isOpen"
        id="commission-setting"
    >
        <div class="mt-2 flex items-center justify-between px-6">
            <h4 class="text-2xl font-bold">Commission Setting</h4>
            <!-- <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon> -->
        </div>
        <vs-divider class="mb-0"></vs-divider>

        <div class="sidebar-content">
            <vs-tabs class="staff-tab-content" style="background: #fff;">
                <vs-tab label="Commission">
                    <div class="con-tab-ejemplo p-3 py-0" style="height: inherit;">
                        <!-- <commission-content @OutConfiguration="outConfiguration" @SaveCommission="saveCommission" :commissionList="commissionList"></commission-content> -->
                        <add-commission-content @FinishCommissionSetting="finishCommissionSetting" @SaveCommission="saveCommission" :commissionSettingConfig="commissionSettingConfig"></add-commission-content>
                    </div>
                </vs-tab>
                <vs-tab label="Salary + Commission">
                    <div class="con-tab-ejemplo p-3 py-0" style="height: inherit;">
                        <!-- <salary-commission-content @OutConfiguration="outConfiguration" @SaveSalaryCommission="saveCommission" :commissionList="commissionList"></salary-commission-content> -->
                        <add-salary-commission-content @FinishCommissionSetting="finishCommissionSetting" @SaveSalaryCommission="saveCommission" :commissionSettingConfig="commissionSettingConfig"></add-salary-commission-content>
                    </div>
                </vs-tab>
                <vs-tab label="Salary">
                    <div class="con-tab-ejemplo p-3 py-0" style="height: inherit;">
                        <!-- <salary-content @OutConfiguration="outConfiguration" @SaveSalary="saveCommission" :commissionList="commissionList"></salary-content> -->
                        <add-salary-content @FinishCommissionSetting="finishCommissionSetting" @SaveSalary="saveCommission" :commissionSettingConfig="commissionSettingConfig"></add-salary-content>
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>
    </vs-sidebar>
</template>

<script>
export default {
    name: 'vs-commission-setting',
    components: {
        SideBarItem: () => import("../../components/SideBarItem.vue")
    },
    props: {
        commissionSettingConfig: {
            type: Object,
            required: true
        },
    },
    data() {
        return {

        }
    },
    methods: {
        saveCommission(data){
          this.$emit("SaveCommission", data)
        },
        finishCommissionSetting(type) {
            this.$emit('FinishCommissionSetting', type);
        }
    }
}
</script>
